import { Controller } from "@hotwired/stimulus"

// Форма рахунку: додавання/видалення позицій та перерахунок підсумку.
export default class extends Controller {
  static targets = ["lineItems"]

  connect() {
    this.calculateTotals()

    this.lineItemsTarget.addEventListener("input", (e) => {
      if (e.target.classList.contains("line-item-quantity") || e.target.classList.contains("line-item-amount")) {
        this.calculateTotals()
      }
    })
  }

  addLineItem(event) {
    event.preventDefault()

    const template = document.getElementById("line-item-template")
    if (!template) return

    const timestamp = new Date().getTime()
    const newContent = template.innerHTML.replace(/NEW_RECORD/g, timestamp)
    this.lineItemsTarget.insertAdjacentHTML("beforeend", newContent)
    this.calculateTotals()
  }

  removeLineItem(event) {
    const lineItem = event.target.closest(".line-item")
    const destroyInput = lineItem.querySelector('input[name$="[_destroy]"]')

    if (destroyInput) {
      destroyInput.value = "1"
      lineItem.style.display = "none"
    } else {
      lineItem.remove()
    }

    this.calculateTotals()
  }

  calculateTotals() {
    let total = 0

    this.lineItemsTarget.querySelectorAll('.line-item:not([style*="display: none"])').forEach(item => {
      const qty = parseFloat(item.querySelector(".line-item-quantity")?.value) || 0
      const amount = parseFloat(item.querySelector(".line-item-amount")?.value) || 0
      const lineTotal = qty * amount
      total += lineTotal

      const totalField = item.querySelector(".line-item-total")
      if (totalField) {
        totalField.value = lineTotal.toFixed(2)
      }
    })

    const totalEl = document.getElementById("total")
    if (totalEl) totalEl.textContent = this.formatCurrency(total)
  }

  formatCurrency(amount) {
    return amount.toLocaleString("uk-UA", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " ₴"
  }
}
